( function( $ ) {
	'use strict';

	$( function() {
		const activeClass = 'site-offcanvas--is-active';

		const $trigger = $( '.js-site-offcanvas-trigger' );
		const $body = $( 'body' );
		const menu = document.querySelector('.js-site-offcanvas');

		// all focusable elements in offcanvas
		// https://gomakethings.com/how-to-get-the-first-and-last-focusable-elements-in-the-dom/
		const focusableList = [...menu.querySelectorAll('button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])')];
		const firstFocus = focusableList[0];

		$trigger.on( 'mouseup', function(e) {
			$body.toggleClass( activeClass );
		} );

		$trigger.on( 'keyup', function(e) {
			const keycode = e.charCode || e.keyCode;

			// enter or space.
			if (keycode === 13 || keycode === 32) {
				$body.toggleClass( activeClass );
				firstFocus.focus();
			}
		} );
	} );
} )( jQuery );
